import { Location, Route } from "vue-router";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import store from "@service/store";
import { hasSessionParams } from "@share/auth/QueryHasSessionParamsHelper";
import { substituteEventId } from "@service/router/helpers/substituteEventId";
import { noEventId } from "@service/router/getters";
import { handleFalsyEventIdParam } from "@service/router/helpers/handleFalsyEventIdParam";

export const handleNextLocation = async (to: Route): Promise<Location | null> => {
    const isAuthed = !!store.state.session.sessionId;
    const selectedEventId = store.state.events?.selected;

    if (!to.name) { return null; }

    const isLoginRoute = to.name == RouteNamesEnum.login;

    if (isLoginRoute && !isAuthed) {
        return null;
    }

    //not logged in and going to the route which is not login
    const notLoggedInAccessingNoneLoginRoute = !isAuthed && !isLoginRoute;
    if (notLoggedInAccessingNoneLoginRoute) {
        store.commit('setAfterLoginPath', to.fullPath);
        return { name: RouteNamesEnum.login, params: to.params, query: hasSessionParams(to) ? to.query : {} };
    }

    //logged in and going to the login route
    if (isLoginRoute && isAuthed && selectedEventId) {
        return { name: RouteNamesEnum.home, params: to.params};
    }

    const routesWithNoEventIdHandling: string[] = [
        RouteNamesEnum.webConferencesRecording,
        RouteNamesEnum.viewMeetingPublic
    ];

    if (routesWithNoEventIdHandling.includes(to.name)) {
        return null;
    }

    //if there is no eventId in the route
    if (!to.params.eventId) {
        return substituteEventId(to, selectedEventId || noEventId, true);
    }

    //if selectedEventId doesnt match the eventId parameter from the route
    const isEventFromRouteAvailable = store.getters["events/eventAvailable"](to.params.eventId);
    if (to.params.eventId !== selectedEventId || !isEventFromRouteAvailable) {
        return handleFalsyEventIdParam(to, selectedEventId, isEventFromRouteAvailable);
    }

    return null;
}
